import { memo, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import { getIsSaveSearch, onDeleteSaveSearch } from "@/api/savedSearch";
import { useLocation } from "react-router";
import { setIsSaveSearch } from "@/redux/SRP/srpSlice";
import { getParams } from "./searchParams";
import { setIsAddedToSaved, showSavedTooltip } from "@/redux/savedpreference/savedPreferenceSlice";
import heart from '../../../public/assets/images/srp/heart.svg';
import heartFilled from '../../../public/assets/images/srp/heartFilled.svg';
import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import { checkLoginStatus } from "@/api/myProfile";
import { logOut } from "@/redux/user/userSlice";

const SaveSearchButton = ({setShowModal, isMobView}) => {
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const globalPopup = useSelector((state) => state.login);
  const isSearchSaved = useSelector((state) => state.srp.saveSearch.isSearchSaved);
  const searchId = useSelector((state) => state.srp.saveSearch.searchId);
  const { polygonId, polygonType } = useSelector((state) => state.srp.srpInitData);
  const srpInitData = useSelector((state) => state.srp.srpInitData);
  const properties = useSelector((state) => state.properties);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const handleLoginClick = () => {
    dispatch(setLoginModal(true));
    dispatch(setLoginTab("loginTab"));
    dispatch(setLoginCallLocation("Popup"));
  };

  const trackGAEvent = (eventName, details) => {
    trackButtonClick({
      eventName,
      eventSource: "Save Search Click",
      eventCategory: "NEW-SRP",
      eventLabel: `${details} | Location: ${getSrpLocationLabel()}`,
    });
  };

  const onSave = async (e) => {
    e.stopPropagation();
     const response = await checkLoginStatus();
        if(response?.isLoggedOut){
          dispatch(logOut({ isUserLoggedIn: false }))
        }
    if (!response?.isLoggedOut || (globalPopup?.isUserSubscribed)) {
      if (isSearchSaved) {
        const response = await onDeleteSaveSearch({searchId, params: getParams({srpInitData, properties, pathname})});
        if (response) {
          dispatch(setIsSaveSearch({isSearchSaved: false, searchId: ""}));
        }
        dispatch(setIsAddedToSaved());
        // dispatch(showSavedTooltip(true));
      } else {
      setShowModal(true)
      trackGAEvent("save_search_name_popup_load", "Save Search Popup Open")
      }
    } else {
      handleLoginClick();
    }
  }

  useEffect(()=>{
    if (globalPopup?.isUserSubscribed){
      setShowModal(false)
    }
  },[globalPopup?.isUserSubscribed])

  useEffect(() => {
    const fetchSearchDetails = async () => {
      if (polygonId && polygonType) {
        const response = await getIsSaveSearch({polygonId, polygonType, params: getParams({srpInitData, properties, pathname})});
        if (response?.isSearchSaved === 'Y') {
          dispatch(setIsSaveSearch({isSearchSaved: true, searchId: response?.searchId}));
        } else {
          dispatch(setIsSaveSearch({isSearchSaved: false, searchId: ""}));
        }
      } else {
        dispatch(setIsSaveSearch({isSearchSaved: false, searchId: ""}));
      }
    }
    fetchSearchDetails()
}, [pathname, srpInitData, properties]);

  return (
    <li
      id={"saved search"}
      className={isMobView ? "" : "list-inline-item menu-item-container"}
      key={`filter-item-saved-search`}
      onClick={onSave}
    >
      <button className="save-search-icon">
        <img src={isSearchSaved ? heartFilled : heart} alt="saveSearch" height={20} width={20} style={{minHeight: 20}} />
        <span className="save-search-text">{isSearchSaved ? "Saved Search" : "Save Search"}</span>
      </button>
    </li>
  );
};

export default memo(SaveSearchButton);
